module.exports = __webpack_public_path__ + "img/MV.4cca1ac7.svg";